<aside style="height: 100%">
  <div style="display: flex">
    <a
      href="https://www.globalbattery.org"
      target="_blank"
      rel="noopener noreferrer"
      class="gba-logo-container"
    >
      <div class="logo-inner-container">
        <img
          src="https://d1sips1sizw66e.cloudfront.net/gba/images/logos/gba_logo.png"
          alt="GBA Logo"
          class="gba-logo"
          height="26px"
          width="77.27px"
        />
      </div>
    </a>
  </div>

  @for (section of sections(); track section.title) {
    <section>
      <lib-card [title]="section.title | translate">
        <ul
          class="nav-list"
          role="list"
        >
          @for (item of section.items; track item.label; let isLast = $last) {
            <li
              class="nav-item"
              [class.last-item]="isLast"
            >
              @if (item.route) {
                <a
                  [routerLink]="item.route"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="nav-link"
                >
                  @if (item.iconName) {
                    <i-feather [name]="item.iconName"></i-feather>
                  }
                  <div>{{ item.label | translate }}</div>

                  @if (item.warning) {
                    <div class="warning-container">
                      <div class="warning-dot"></div>
                    </div>
                  }
                </a>
              } @else {
                <button
                  (click)="item.click?.()"
                  class="nav-link nav-button"
                >
                  @if (item.iconName) {
                    <i-feather [name]="item.iconName"></i-feather>
                  }
                  {{ item.label }}
                </button>
              }
            </li>
          }
        </ul>
      </lib-card>
    </section>
  }

  <div class="logo-outer-container">
    <p class="label">Developed by</p>
    <div style="display: flex">
      <div class="logo-inner-container">
        <img
          src="https://d1sips1sizw66e.cloudfront.net/gba/images/logos/itc_logo_white.svg"
          alt="ITC Logo"
          class="logo"
          height="34px"
          width="80.75px"
        />
      </div>
    </div>
  </div>
</aside>
